export const INDIGNANT = 'indignant'
export const POPULAR_GIRL = 'popularGirl'
